module.exports = __webpack_public_path__ + "img/mainForm-bg.58f0aa65.png";